<template>
        <!-- Middle Pic Offset  -->
  <!-- <div class="eventBanner h-48 m-4 dupr md:absolute hidden rounded-lg border-8  shadow-sm  md:flex md:justify-end  bg-slate-50 ">        
    <div class="w-4/5 justify-center mt-5 p-5 text-3xl">      

    </div>       
   
     
  </div>   -->
  <div class="gridSplash h-max-full bg-walter-primary">
    <div class=" bg-black col-span-full row-span-full md:col-start-2 md:col-end-5  md:row-start-1 md:row-end-4 ">
      <img src="../assets/lifetimeSchedule.jpg" class="" alt="DUPR iOS App">
    </div>
    
  </div>
  

</template>

<script>
export default {
    data(){ 
      return {
        clinics : [
          {name: "Live Ball Fridays 11:30 El Camino Country Club"}          
        ]
      }
    }
}

</script>

<style>
.nature{
  background-color: white;
  color: rgb(224, 46, 46);
  font-size: 25vw; 
  font-weight: bold;
  margin: 0 auto;
  padding: 10px;
  width: 50%;
  text-align: center;
   position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  mix-blend-mode:saturation;
}
.club{
  color: #FFFFFF;

  text-shadow: 2px 2px 0 #4074b5, 2px -2px 0 #4074b5, -2px 2px 0 #4074b5, -2px -2px 0 #4074b5, 2px 0px 0 #4074b5, 0px 2px 0 #4074b5, -2px 0px 0 #4074b5, 0px -2px 0 #4074b5;
}
.glow { 

  font-family: 'Concert One', 'Times New Roman', serif
}

.eventBanner{
  left: 10%;
  top: 60%;
  width: 70%;
}


        
</style>